export enum ProjectStatus {
  NotScored = "Not Scored",
  InProgress = "In Progress",
  Scored = "Scored",
  Error = "Error",
}

const statusDisplayText: Partial<Record<ProjectStatus, string>> = {
  [ProjectStatus.Error]: "Failed",
};

export const getStatusDisplayText = (status: string | undefined): string =>
  statusDisplayText[status as ProjectStatus] ??
  status ??
  ProjectStatus.NotScored;

export const PROJECT_TOOLTIPS = {
  SCORE: {
    IN_PROGRESS: "In Progress",
    NO_ATTACHMENTS: "Add attachments to enable scoring",
    NO_CONTENT_COLUMN: "Select a content column in at least one attachment",
    READY: "Score project",
    RE_SCORE: "Re-Score project",
  },
  OPEN: {
    ENABLED: "Open project",
    DISABLED: "Score the project first to open",
  },
  EXPORT: {
    ENABLED: "Export project data",
    DISABLED: "Score the project first to export",
  },
} as const;
